import { useFeatureFlag } from '@moda/portal-stanchions';
import { FacadePageType, getRuleContextFromSlug } from '../lib/getRuleContextFromSlug';
import { usePLPPinnedVariantIdVariables } from './usePLPPinnedVariantIdVariables';
import { useIsPinningDisabledOnPLP } from './useIsPinningDisabledOnPLP';

export const useRuleVariables = (type: FacadePageType, slug: string) => {
  const pinnedVariantIdVariables = usePLPPinnedVariantIdVariables();
  const ruleContext = getRuleContextFromSlug(type, slug);

  const isAbTest = useFeatureFlag(`${ruleContext}_test`, [
    { default: false },
    { if: true, then: true }
  ]);

  const noPinning = useIsPinningDisabledOnPLP(type);

  const ruleContexts = isAbTest ? `${ruleContext}_test` : ruleContext;

  if (pinnedVariantIdVariables) return pinnedVariantIdVariables;

  return {
    ruleContexts: noPinning ? [] : ruleContexts,
    rules: []
  };
};
